// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609210804/js/" + chunkId + "." + {"44":"20ab08e1","225":"cb677d16","481":"9b08a14e","486":"f6bd529d","770":"24237ea5"}[chunkId] + ".0.9976159388735188.chunk.js";
};